import { useState, useEffect } from 'react'
import { Button } from '../../../../../components'
import { Table } from 'react-bootstrap'
import {
  getAmt,
  getQty,
  getTime,
  getOrderSummary,
} from '../../../lib/onlpos-utils'
import { getPriceStr } from '../../../../../lib/utils'
import { OrderEditMoal } from './OrderEditModal'
import { onlposUpdateOrderStatus2 } from '../../../lib/api-onlpos'

export function LeftBox(props) {
  const { selectedTableInfo, tableOrderList } = props

  const [selectedOrder, setSelectedOrder] = useState({})
  const [visibleOrderEdit, setVisibleOrderEdit] = useState(false)

  const allProps = { ...props, setVisibleOrderEdit, setSelectedOrder }

  const styles = {
    wrap: {
      // flex: 5,
      width: '45%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    top: {
      flex: 1,
      backgroundColor: '#fff',
      overflowY: 'scroll',
    },
    topTitle: {
      ...props.gStyle.subtitle,
      backgroundColor: props.colors.info,
      color: props.colors.light,
      padding: 5,
    },
    btm: {
      backgroundColor: props.colors.light,
      padding: 5,
    },
  }
  return (
    <div style={styles.wrap}>
      <div style={styles.top}>
        <h3 style={styles.topTitle}>{selectedTableInfo.tableName}</h3>
        <OrderTable {...allProps} tableOrderList={tableOrderList} />
      </div>
      <div style={styles.btm}>
        {/* <Buttons1 {...allProps} /> */}
        <TotalSum {...allProps} />
        <Buttons2 {...allProps} />
        <Buttons3 {...allProps} />
      </div>

      {visibleOrderEdit && (
        <OrderEditMoal
          {...allProps}
          visible={visibleOrderEdit}
          setIsVisible={setVisibleOrderEdit}
          selectedOrder={selectedOrder}
        />
      )}
    </div>
  )
}

function OrderTable(props) {
  const { tableOrderList, setVisibleOrderEdit, setSelectedOrder } = props

  const headerNames = ['메뉴명', '단가', '수량', '합계', '시간', '비고']

  const styles = {
    text: {
      ...props.gStyle.text,
      fontSize: '0.8rem',
    },
    prc: {
      ...props.gStyle.text,
      fontSize: '0.8rem',
      textAlign: 'right',
    },
  }

  return (
    <Table striped>
      <thead>
        <tr>
          {headerNames.map((nm, i) => {
            return <th key={'h' + i}>{nm}</th>
          })}
        </tr>
      </thead>
      <tbody>
        {tableOrderList.map((ord, i) => {
          return (
            <tr
              key={'order-line-' + i}
              onClick={() => {
                setSelectedOrder(ord)
                setVisibleOrderEdit(true)
              }}
            >
              <td>
                <p
                  style={{
                    ...styles.text,
                    fontWeight: ord.type === 'option' ? 300 : 500,
                    marginLeft: ord.type === 'option' ? 15 : 0,
                  }}
                >
                  {ord.type === 'option' ? ' - ' : ''}
                  {ord.itemName || ord.optionItemName}
                </p>
              </td>
              <td style={styles.prc}>{getPriceStr(ord.price)}</td>
              <td style={styles.prc}>{getQty(ord, tableOrderList)}</td>
              <td style={styles.prc}>
                {getPriceStr(getAmt(ord, tableOrderList))}
              </td>
              <td style={styles.text}>{getTime(ord.ct)}</td>
              <td style={styles.text}>??</td>
            </tr>
          )
        })}
      </tbody>
    </Table>
  )
}

function TotalSum(props) {
  const {
    shopInfo,
    orderList,
    selectedTableInfo,
    tableOrderList,
    updateOrderList,
    gStyle,
  } = props

  const [totalAmt, setTotalAmt] = useState(0)

  useEffect(() => {
    let tableOrderList = []
    const tableOrders = orderList.filter(
      (o) => o.tableCode === selectedTableInfo.tableCode,
    )
    if (tableOrders.length === 1) {
      tableOrderList = tableOrders[0].orderData?.orderList
    }
    const orderSummary = getOrderSummary(tableOrderList)
    setTotalAmt(orderSummary.orderAmt)
  }, [orderList])

  const styles = {
    wrap: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      margin: '10px 3px',
    },
  }
  return (
    <div style={styles.wrap}>
      <p style={gStyle.text}>
        전체 금액:{' '}
        <span style={{ fontWeight: 'bold' }}>{getPriceStr(totalAmt)}</span>
      </p>
    </div>
  )
}

// function Buttons1(props) {
//   const styles = {
//     wrap: {
//       display: 'flex',
//       alignItems: 'center',
//       margin: '10px 3px',
//       // marginBottom: 8,
//     },
//     btn: { marginRight: 3, flex: 1 },
//   }
//   return (
//     <div style={styles.wrap}>
//       <Button size="sm" variant="outline-info" style={styles.btn}>
//         <ChevronU />
//       </Button>
//       <Button size="sm" variant="outline-info" style={styles.btn}>
//         <ChevronD />
//       </Button>
//       <Button size="sm" variant="outline-info" style={styles.btn}>
//         주문메모
//       </Button>
//       <p style={{ ...props.gStyle.text, textAlign: 'center', flex: 1 }}>수량</p>
//     </div>
//   )
// }

function Buttons2(props) {
  const {
    shopInfo,
    orderList,
    selectedTableInfo,
    tableOrderList,
    updateOrderList,
  } = props

  const onRemoveAll = async () => {
    try {
      const tableOrders = orderList.filter(
        (o) => o.tableCode === selectedTableInfo.tableCode,
      )
      if (tableOrders.length !== 1) {
        throw Error('No Order Found!')
      }

      const orderObj = tableOrders[0]

      if (orderObj.orderData?.orderList.length === 0) {
        throw Error('No Order Found!')
      }

      const params = {
        shopInfo,
        tableCode: selectedTableInfo.tableCode,
        body: {
          orderData: JSON.stringify({
            ...orderObj.orderData,
            orderList: [],
          }),
        },
      }

      let res = await onlposUpdateOrderStatus2(params)
      if (res.err) throw Error(res.err.message)
      await updateOrderList()
    } catch (e) {
      alert(e.message)
    }
  }

  const styles = {
    wrap: {
      display: 'flex',
      alignItems: 'center',
      margin: 3,
    },
    btn: { marginRight: 3, flex: 1 },
    btn2: { marginRight: 3, display: 'flex', justifyContent: 'space-around' },
    iconBox: {
      ...props.gStyle.text,
      width: 25,
      height: 25,
      border: '1px solid ' + props.colors.info,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }
  return (
    <div style={styles.wrap}>
      <Button variant="outline-info" style={styles.btn} onClick={onRemoveAll}>
        전체 취소
      </Button>

      <Button
        variant="outline-secondary"
        style={styles.btn}
        onClick={() => alert('주문메모??')}
      >
        주문메모
      </Button>

      <Button
        variant="outline-secondary"
        style={styles.btn}
        onClick={() => alert('포장??')}
      >
        포장
      </Button>

      {/* <div style={styles.btn}>
        <div style={styles.btn2}>
          <p style={styles.iconBox}>
            <Plus style={{ color: props.colors.danger }} />
          </p>
          <p style={styles.iconBox}>
            <Minus style={{ color: props.colors.danger }} />
          </p>
        </div>
        <p style={{ ...props.gStyle.text, textAlign: 'center' }}>수량변경</p>
      </div> */}
    </div>
  )
}

function Buttons3(props) {
  const styles = {
    wrap: {
      display: 'flex',
      alignItems: 'center',
      margin: 3,
    },
    btn: {
      marginRight: 3,
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    text: { ...props.gStyle.text, fontSize: '0.8rem' },
  }
  return (
    <div style={styles.wrap}>
      <Button
        variant="outline-secondary"
        style={styles.btn}
        onClick={() => alert('주방 재전송??')}
      >
        주방<span>재전송</span>
      </Button>

      <Button
        variant="outline-secondary"
        style={styles.btn}
        onClick={() => alert('서비스 취소??')}
      >
        서비스<span>취소</span>
      </Button>

      <Button
        variant="outline-secondary"
        style={styles.btn}
        onClick={() => alert('상세조회??')}
      >
        상세조회
      </Button>

      <Button
        variant="outline-secondary"
        style={styles.btn}
        onClick={() => alert('계산서 출력??')}
      >
        계산서<span>출력</span>
      </Button>
    </div>
  )
}
